module.exports = __webpack_public_path__ + "img/IMG_5350.9fc0ec9e.jpg";